<template>
  <div>
    <Header></Header>
    <div class="content">
      <div class="cont-left">
        <h4>{{ player.title == null ? "打桩伤害" : player.title }}</h4>
        <div class="title">
          {{ player.playcount }}播放 {{ dateFormat(player.createdate) }}
        </div>
        <video id="playervideo" width="480" height="320" controls>
          <source :src="videopath" type="video/mp4" />
          您的浏览器不支持 HTML5 video 标签。
        </video>
        <div>
          <a href="javascript:;" v-on:click="clickLikeBtn"
            ><span
              v-if="me.like_state == true"
              class="icon iconfont icon-liked"
            ></span
            ><span
              v-if="me.like_state == false"
              class="icon iconfont icon-like"
            ></span
            ><a href="javascript:;" class="readnum2">{{ likeCount }}</a></a
          >
        </div>
        <div class="comm">
          <h4>{{ commCount }} 评论</h4>
          <div class="">
            <el-input
              type="textarea"
              placeholder="请输入内容"
              :rows="4"
              maxlength="120"
              v-model="rplcont"
              show-word-limit
            >
            </el-input>
            <div class="replybtns">
              <el-button
                type="primary"
                @click="reply($event, 0, 0, '', player.uid)"
                plain
                >发表回复</el-button
              >
            </div>
            <div style="clear: both"></div>

            <div
              class="comm-cont"
              v-for="(item, index) in commList[0]"
              :key="index"
            >
              <div>
                <div class="avatar">
                  <el-avatar :size="sizeList[1]" :src="circleUrl"></el-avatar>
                </div>
                <div class="comm-detail">
                  <span class="name">{{ item.displayname }}</span>
                  <!-- <a href="/">查看评论</a> -->
                  <div class="cont">{{ item.cont }}</div>
                  <div class="date">
                    {{ dateFormat(item.create_date)
                    }}<a href="##" v-on:click="repleyShow($event)">回复</a>
                    <!-- <a href="#">举报</a> -->
                    <!-- <a href="#">删除</a> -->
                  </div>
                  <div class="replyarea">
                    <el-input
                      type="textarea"
                      placeholder="请输入内容"
                      :rows="4"
                      v-model="rplcont"
                      maxlength="120"
                      show-word-limit
                    >
                    </el-input>
                    <div class="replybtns">
                      <el-button
                        type="primary"
                        @click="
                          reply(
                            $event,
                            item.id,
                            item.comment_id == 0 ? item.id : item.comment_id,
                            item.displayname,
                            item.uid
                          )
                        "
                        plain
                        >发表回复</el-button
                      >
                    </div>
                  </div>
                </div>
              </div>
              <!-- 二级评论 -->
              <div
                class="comm-level2"
                v-for="(item2, index2) in commList[1]"
                :key="index2"
              >
                <div v-if="item.id == item2.comment_id && index2 < 5">
                  <div class="avatar-level2">
                    <el-avatar :size="sizeList[2]" :src="circleUrl"></el-avatar>
                  </div>
                  <div class="comm-detail">
                    <span class="name">{{ item2.replied_name }}</span> 回复
                    <span class="name"> @{{ item2.displayname }}</span> 的评论<a
                      href="/"
                      >查看评论</a
                    >
                    <div class="cont">{{ item2.cont }}</div>
                    <div class="date">
                      {{ dateFormat(item2.create_date)
                      }}<a href="##" v-on:click="repleyShow($event)">回复</a>
                      <!-- <a href="#">举报</a> -->
                      <!-- <a href="#">删除</a> -->
                    </div>
                    <div class="replyarea">
                      <el-input
                        type="textarea"
                        placeholder="请输入内容"
                        :rows="4"
                        v-model="rplcont"
                        maxlength="120"
                        show-word-limit
                      >
                      </el-input>
                      <div class="replybtns">
                        <el-button
                          type="primary"
                          @click="
                            reply(
                              $event,
                              item2.id,
                              item.comment_id == 0 ? item.id : item.comment_id,
                              item.displayname,
                              item.uid
                            )
                          "
                          plain
                          >发表回复</el-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div style="clear: both"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="cont-right">
        <div class="userinfo">
          <div class="u-left">
            <a :href="'/userdetail?id='" target="_blank">
              <el-avatar
                :size="user.photo == '' ? sizeList[0] : user.photo"
                :src="circleUrl"
              ></el-avatar>
            </a>
          </div>
          <div class="u-right">
            <h3>
              {{ user.username }}<br /><span class="desc">{{
                user.desc == null ? "这个人很懒，什么也没留下" : user.desc
              }}</span>
            </h3>
            <el-button v-if="me.follow_state == false" @click="clickFocusBtn(1)"
              >+关注{{ follerCount }}</el-button
            >
            <div v-if="me.follow_state == true">
              <el-dropdown>
                <span class="el-dropdown-link">
                  <el-button>已关注</el-button>
                  <!-- 已关注<i class="el-icon-arrow-down el-icon--right"></i> -->
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="clickFocusBtn(0)"
                    >取消关注</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.content {
  width: 980px;
  margin: 0 auto;
  display: flex;
  padding: 16px;
}
.title {
  color: #999;
  font-size: 12px;
  margin-bottom: 8px;
}
.cont-left {
  width: 508px;
}
.cont-right {
  margin-left: 16px;
  position: relative;
  width: 320px;
}
.readnum2 {
  font-size: 14px;
  margin-left: 8px;
  margin-right: 8px;
}
.replybtns {
  margin-top: 16px;
  float: right;
}
.u-left {
  position: absolute;
  top: 24px;
  left: 24px;
}
.u-right {
  margin-left: 70px;
  margin-top: 20px;
}
.desc {
  font-weight: normal;
  font-size: 13px;
  color: #999;
}
.u-right a {
  margin-right: 20px;
}

/*回复评论*/
.comm-cont {
  border-bottom: #e2e2e2 1px solid;
  margin-top: 32px;
  position: relative;
  padding-bottom: 32px;
}
.avatar {
  display: inline-block;
  position: absolute;
  left: 0;
}
.comm-level2 {
  margin-left: 45px;
  margin-top: 12px;
  position: relative;
}
.avatar-level2 {
  display: inline-block;
  position: absolute;
  left: 12px;
  top: 2px;
}
.avatar {
  vertical-align: middle;
  padding-top: 8px;
}
.comm-detail {
  margin-left: 55px;
}
.date,
.date a {
  color: #999;
  font-size: 14px;
}
.date a {
  margin-left: 16px;
}
.name {
  color: #757575;
  font-size: 14px;
}
.mr-10 {
  margin-right: 10px;
}
.ml-20 {
  margin-left: 20px;
}
.cont {
  padding: 16px 0 16px 0;
}
.comm-num {
  color: #999;
  font-size: 14px;
  font-weight: normal;
}
.see-comm {
  color: #00a1d6;
  margin-left: 16px;
  font-size: 14px;
}
a:hover {
  color: #00a1d6;
}
.ava-check {
  float: left;
  padding: 8px;
  padding-right: 16px;
}
.replyarea {
  max-width: 800px;
  margin-top: 8px;
  display: none;
}
</style>

<script>
import Header from "./headernew";
export default {
  components: {
    Header,
  },
  mounted() {
    var href = location.href;
    var params = href.split("?")[1];
    var params2 = params.split("&");
    this.id = parseInt(params2[0].split("=")[1]);
    this.uid = parseInt(params2[1].split("=")[1]);
    //var vpath = params2[2];
    //this.videopath =
    //"https://localhost:44328" +
    //decodeURIComponent(vpath.split("=")[1].replace(" ", ""));

    this.getCommentList(this.id);
    this.getUserInfo();
    this.getPlayerInfo();
    var _uid = localStorage.getItem("loginuid");
    this.loginuid = _uid == null || _uid == undefined ? 0 : parseInt(_uid);
    this.getMeState();
    this.recordPlayCount();
    this.getLikeCount();
  },
  data() {
    return {
      videopath: "",
      commCount: 0,
      follerCount: 0,
      id: 0,
      uid: 0,
      loginuid: 0,
      likeCount: 0,
      circleUrl:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      squareUrl:
        "https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png",
      sizeList: ["large", "medium", "small"],
      rplcont: "",
      commList: [],
      user: { username: "", photo: "", desc: "" },
      player: { title: "", vpaht: "", playcount: 0, createdate: "" },
      me: {},
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    dateFormat(date) {
      return date.replace("T", " ").split(".")[0];
    },
    reply(e, pid, commid, disname, uid) {
      console.log(e.target);
      console.log(e.target.parentNode.parentNode.parentNode);
      if (this.loginuid == 0) {
        //未登录
        this.$alert("请先登录", "", {
          confirmButtonText: "确定",
        });
        return;
      }
      if (this.rplcont == "") {
        this.$alert("请填写内容", "", {
          confirmButtonText: "确定",
        });
      }
      var cont = this.rplcont;
      this.rplcont = "";
      this.$http
        .post("/api/PlayerDetailComment/", {
          cont: cont,
          parent_id: pid,
          comment_id: commid,
          cont_id: this.id,
          replied_uid: uid,
          replied_name: disname,
        })
        .then((r) => {
          console.log(r);
          //获取角色列表
          if (r.data.code == 200) {
            this.$alert("评论成功", "", {
              confirmButtonText: "确定",
            });
            if (pid > 0) {
              this.repleyShow2(e);
            }

            this.getCommentList(this.id);
          } else {
            this.$alert("获取数据失败，请重试", "", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    repleyShow2: function (e) {
      //显示和隐藏文本框
      var cur = e.target;
      var displayArea = cur.parentNode.parentNode;
      var disstate = displayArea.style.display;
      if (disstate === "" || disstate === "none") {
        displayArea.style.display = "block";
      } else {
        displayArea.style.display = "none";
      }
    },
    repleyShow: function (e) {
      //显示和隐藏文本框
      var cur = e.currentTarget;
      var displayArea = cur.parentNode.nextSibling;
      var disstate = displayArea.style.display;
      if (disstate === "" || disstate === "none") {
        displayArea.style.display = "block";
      } else {
        displayArea.style.display = "none";
      }
    },
    getCommentList(cont_id) {
      this.$http
        .get("/api/PlayerDetailComment?cont_id=" + cont_id)
        .then((r) => {
          if (r.data.code == 200) {
            this.commList = r.data.data;
            this.commCount = this.commList[0].length + this.commList[1].length;
          } else {
            this.$alert("获取数据失败，请重试", "", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getFollerCount() {
      this.$http
        .get("/api/Follower/")
        .then((r) => {
          console.log(r);
          var count = r.data;
          if (count > 1000) {
            count = count / 1000.0;
          }
          this.follerCount = count;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getUserInfo() {
      this.$http
        .get("/api/user/" + this.uid)
        .then((r) => {
          console.log(r);
          this.user = r.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getPlayerInfo() {
      this.$http
        .get("/api/PlayerSingle/" + this.id)
        .then((r) => {
          console.log(r);
          this.player = r.data;
          var vpath = this.GLOBAL.baseURL + r.data.videopath;
          // this.videopath =vpath;
          document.getElementById("playervideo").src = vpath;
          document.getElementById("playervideo").play();
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getLikeCount() {
      this.$http
        .get("/api/like/" + this.id)
        .then((r) => {
          console.log(r);
          this.likeCount = r.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getMeState() {
      //获取我相关的关注及点赞状态
      this.$http
        .get("/api/me/" + this.uid + "/" + this.id)
        .then((r) => {
          console.log(r);
          this.me = r.data.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    clickFocusBtn(cancelOrFollow) {
      //点击关注
      if (this.loginuid == 0) {
        //未登录
        this.$alert("请先登录", "", {
          confirmButtonText: "确定",
        });
        return;
      }
      this.$http
        .post("/api/follower/", { follwer_uid: this.uid, opt: cancelOrFollow })
        .then((r) => {
          console.log(r);
          //获取角色列表
          if (r.data == 0) {
            var strTip = "取消关注成功";
            if (cancelOrFollow == 1) {
              strTip = "关注成功";
            }
            this.$alert(strTip, "", {
              confirmButtonText: "确定",
            });
          } else {
            var strTip2 = "取消关注失败,请重试";
            if (cancelOrFollow == 1) {
              strTip2 = "关注失败,请重试";
            }
            this.$alert(strTip2, "", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    clickLikeBtn() {
      //点赞功能
      if (this.loginuid == 0) {
        //未登录
        this.$alert("请先登录", "", {
          confirmButtonText: "确定",
        });
        return;
      }
      let _this = this;
      this.$http
        .post("/api/like/", {
          cont_id: this.id,
          uid: this.loginuid,
          beuid: this.uid,
        })
        .then((r) => {
          console.log(r);
          //获取角色列表
          if (r.data.code == 200) {
            if (_this.me.like_state == true) {
              //现在是取消点赞
              _this.me.like_state = false;
              _this.likeCount -= 1;
            } else {
              _this.me.like_state = true;
              _this.likeCount += 1;
            }
            this.$alert(r.data.msg, "", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("操作失败，请重试", "", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    recordPlayCount() {
      //记录播放量
      this.$http
        .post("/api/video?id=" + this.id)
        .then((r) => {
          console.log(r);
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>

